import { render } from "./InvitationRecordsDialog.vue?vue&type=template&id=addcaa20&scoped=true"
import script from "./InvitationRecordsDialog.vue?vue&type=script&lang=js"
export * from "./InvitationRecordsDialog.vue?vue&type=script&lang=js"

import "./InvitationRecordsDialog.vue?vue&type=style&index=0&id=addcaa20&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addcaa20"]])

export default __exports__